import _ from 'lodash';
import Element from './Element';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';
import mixin from '../privates/utils/mixin';
import * as members from '../privates/privateMembers';
import menuUtils from '../privates/utils/menuUtils';
import {validate} from '../privates/validations/validation';


/**
 * @class AccountNavBar
 * @summary The menu in a user profile.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 * @queryable
 * @tagname AccountNavBar
 * @viewername wysiwyg.viewer.components.LoginSocialBar
 * @definitionId wysiwyg.viewer.components.LoginSocialBar
 */
class AccountNavBar extends Element {

    set menuItems(menuItems) {
        const RMI = members._RMI.get(this);
        const compType = members._type.get(this).compType;
        if (!validate({
            compType,
            functionName: 'menuItems',
            dataToValidate: {menuItems},
            compName: this.id
        })) {
            return this;
        }
        if (_.isNil(menuItems)){
            menuItems = [];
        }
        const validMenuItems = menuUtils.checkUserProfileMenuItemsValidation({
            navItems: menuItems,
            functionName: 'menuItems',
            compName: this.id
        });
        const convertedMenuItems = _.map(validMenuItems, (menuItem, menuItemIndex) => {
            return menuUtils.convertMenuItemToModelFormat(RMI, menuItem, menuItemIndex, 'menuItems');
        });

        RMI.setData(members._compId.get(this), {menuItemsRef: {type: 'CustomMenuDataRef', menuRef: {type: 'CustomMenu', items: convertedMenuItems}}});
    }

    get menuItems() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const data = RMI.getData(compId);
        const menuItems = _.get(data, 'menuItemsRef.menuRef.items');
        return _.map(menuItems, (menuItem) => {return menuUtils.convertNavItemToUserFormat(menuItem);});
    }

    set navBarItems(navBarItems) {
        const RMI = members._RMI.get(this);
        const compType = members._type.get(this).compType;
        if (!validate({
            compType,
            functionName: 'navBarItems',
            dataToValidate: {navBarItems},
            compName: this.id
        })) {
            return this;
        }
        if (_.isNil(navBarItems)){
            navBarItems = [];
        }
        const validNavBarItems = menuUtils.checkUserProfileNavBarItemsValidation({
            navItems: navBarItems,
            functionName: 'navBarItems',
            compName: this.id
        });
        const convertedNavItems = _.map(validNavBarItems, (navItem, navItemIndex) => {
            return menuUtils.convertMenuItemToModelFormat(RMI, navItem, navItemIndex, 'navBarItems', true);
        });
        RMI.setData(members._compId.get(this), {iconItemsRef: {type: 'CustomMenuDataRef', menuRef: {type: 'CustomMenu', items: convertedNavItems}}});
    }

    get navBarItems() {
        const RMI = members._RMI.get(this);
        const compId = members._compId.get(this);
        const data = RMI.getData(compId);
        const navBarItems = _.get(data, 'iconItemsRef.menuRef.items');
        return _.map(navBarItems, (navBarItem) => {return menuUtils.convertNavItemToUserFormat(navBarItem);});
    }

}

mixin(AccountNavBar.prototype, HiddenCollapsedMixin.prototype);

export default AccountNavBar;
